import { render, staticRenderFns } from "./SelectExtrusionOrderModal.vue?vue&type=template&id=c4c54808&scoped=true&"
import script from "./SelectExtrusionOrderModal.vue?vue&type=script&lang=js&"
export * from "./SelectExtrusionOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectExtrusionOrderModal.vue?vue&type=style&index=0&id=c4c54808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c54808",
  null
  
)

export default component.exports